import { FileChip } from "@/components/files/FileChip.tsx";
import { useCallback } from "react";
import { ARIA_LABELS } from "./constants.ts";
import type { AttachedFile } from "./types.ts";

interface FileAttachmentProps {
  attachedFiles: AttachedFile[];
  onFilesChange: (files: AttachedFile[]) => void;
  /** Show the chips without their remove control, e.g. while they upload. */
  readOnly?: boolean;
}

export const FileAttachment: React.FC<FileAttachmentProps> = ({
  attachedFiles,
  onFilesChange,
  readOnly = false,
}) => {
  const removeAttachedFile = useCallback(
    (file: File) => {
      onFilesChange(attachedFiles.filter((af) => af.file !== file));
    },
    [attachedFiles, onFilesChange],
  );

  return (
    <>
      {/* File attachments preview */}
      {attachedFiles.length > 0 && (
        <div className="flex flex-wrap gap-2">
          {attachedFiles.map((attachedFile) => (
            <FileChip
              key={attachedFile.id}
              name={attachedFile.file.name}
              subtitle={
                attachedFile.uploading ? "Uploading..." : attachedFile.error || "Ready to send"
              }
              previewUrl={attachedFile.preview}
              status={attachedFile.error ? "error" : attachedFile.uploading ? "uploading" : "ready"}
              onRemove={readOnly ? undefined : () => removeAttachedFile(attachedFile.file)}
              removeAriaLabel={ARIA_LABELS.REMOVE_FILE}
              removeStatsigName="omnibox-file-remove"
            />
          ))}
        </div>
      )}
    </>
  );
};
